import request from '@/utils/request'
import store from '@/store'
import dayjs from 'dayjs'

export function submit(url, data, flag, header) {
  return request({
    url,
    data: data || {},
    header: header || null,
    flag: flag || false,
  })
}

export function getRoutes() {
  return submit('/api/config/getRouteConfig')
}

export function getPageConfig(data) {
  return submit('/api/config/getPageConfig', data || {})
}

export function saveSystemSetting(setting) {
  if (!setting) return
  return submit('/api/stall/saveSystemSetting', setting)
}

export function getQQCount() {
  return submit('/api/StallBotAccount/GetQQCount')
}

export function exportFile(url, data) {
  return request({
    url,
    data: data || {},
    responseType: 'blob',
  })
}
